import { dispatch } from '@store/index';
import { resetStep } from '@store/slices/login.slice';
import { navigateToHomeWithLounge } from '@utils/helpers';
import { Avatar, Dropdown } from 'flowbite-react';
import { useNavigate, useLocation } from 'react-router-dom';

const UserDropdown = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const loungeIds = searchParams.get('loungeId');

  const handleSignOut = () => {
    dispatch(resetStep());
    navigateToHomeWithLounge(navigate, loungeIds);
  };

  return (
    <Dropdown
      label="UserDropdown"
      renderTrigger={() => <Avatar rounded className="absolute right-0 mr-3" />}
      className="!left-[unset] !top-[45px] right-0 mr-3 mt-10"
    >
      <Dropdown.Item onClick={handleSignOut}>Sign out</Dropdown.Item>
    </Dropdown>
  );
};

export default UserDropdown;
